'use strict';

class FormManager {
    constructor(config = {}) {
        this.config = {
            ignore: [],
            rules: {},
            messages: {},
            errorElement: 'span',
            errorClass: 'error',
            errorPlacement: function (error, element) {
                error.appendTo( element.parents('.field') );
            },
            highlight: function (element) {
                jQuery(element).addClass('invalid');
            },
            unhighlight: function (element) {
                jQuery(element).removeClass('invalid');
            },
            submitHandler: function (form) {
                const $form = jQuery(form);
                const formSettings = this.settings;
                const formData = new FormData(form);

                $form.find('.formResponse').remove();

                if (formSettings.beforeSubmit &&
                    formSettings.beforeSubmit.call(this, form, formData, formSettings) === false) {
                    return false;
                }

                $form.addClass('loading');

                const ajaxConfig = jQuery.extend(true, {}, {
                    method: $form.attr('method') || 'POST',
                    data: formData,
                    processData: false, // Important! Tell jQuery not to process the data
                    contentType: false, // Important! Tell jQuery not to set contentType
                    onSuccess: function (response) {
                        if (formSettings.onSuccess && formSettings.onSuccess.call(this, response, formSettings) === false) {
                            return false;
                        }

                        if ( formSettings.resetOnSuccess ) {
                            form.reset();
                        }

                        if ( response.success ) {
                            popupManager.setContent(response.data.content);
                        } else {
                            jQuery('<div class="formResponse"></div>').html(response.data.content).appendTo($form.find('.formBody'));
                        }

                        return false;
                    },
                    onError: function (response) {
                        jQuery('<div class="formResponse"></div>').html(response.data.content).appendTo($form.find('.formBody'));
                        return false;
                    },
                    onComplete: function () {
                        $form.removeClass('loading');
                    }
                }, formSettings.ajaxSettings );
                ajaxManager.request(ajaxConfig);
            },
            onInit: null,
            beforeSubmit: null,
            onSuccess: null,
            resetOnSuccess: true,
            ajaxSettings: {},
            ...config
        };
    }

    initForm(selector, options) {
        const settings = jQuery.extend(true, {}, this.config, options);

        jQuery(document).on('afterShow.fb', function( e, instance, slide ) {
            if (settings.onInit && settings.onInit.call(this, selector, settings) === false) {
                return false;
            }
            slide.$slide.find(selector).validate(settings);
        });

        return jQuery(selector).each(function (index, form) {
            if (settings.onInit && settings.onInit.call(this, selector, settings) === false) {
                return false;
            }

            jQuery(form).validate(settings);
        });
    }
}

window.formManager = new FormManager();
